import * as React from "react";
import {
    AppState,
    IndustryMapping,
    CategoryMapping,
    signupFormBindings,
    signupForm,
    sendSignupAction,
    uploadMappingsForSignup,
    changeStatusSignupModalAction,
    validateEmail
} from "@store";
import { Dispatch, connect } from "react-redux";
import "./SignupComponent.css";
import { FetchingState } from "rd-redux-http";
import { Fieldset } from "./Fieldset";
import * as cn from "classnames";
import { Triangle } from "@icons";

export interface SignupComponentProps {
    signupFormData: typeof signupForm.types.selectorResult;
    signupFormEvents: typeof signupForm.types.eventBindings;
    industriesMapping: IndustryMapping[];
    categoriesMapping: CategoryMapping[];
    onChangeStatusSignupModal: (isOpen: boolean) => void;
    onUploadDropdowns: () => void;
    onSendSignup: () => void;
}

export interface SignupComponentState {}

class SignupComponent extends React.Component<SignupComponentProps, SignupComponentState> {
    componentDidMount() {
        this.props.onUploadDropdowns();
    }

    render() {
        const {
            onChangeStatusSignupModal,
            industriesMapping,
            categoriesMapping,
            onSendSignup,
            signupFormData: form,
            signupFormEvents: events
        } = this.props;

        const isValid: boolean = form.isValid && validateEmail(form.fields.email.value);

        return (
            <div className="signup">
                <h3 className="signup-title">Signup newsletter</h3>
                <div className="signup-item-wrapper">
                    <Fieldset
                        className="custom-signup-fieldset signup-item"
                        label="Company"
                        errorMessage={form.fields.name}
                        isMandatory={true}
                    >
                        <input type="text" name="" id="" value={form.fields.name.value || ""} {...events.fields.name} />
                    </Fieldset>
                    <Fieldset
                        className="custom-signup-fieldset signup-item"
                        label="Email"
                        errorMessage={form.fields.email}
                        isMandatory={true}
                    >
                        <input
                            type="text"
                            name=""
                            id=""
                            value={form.fields.email.value || ""}
                            {...events.fields.email}
                        />
                    </Fieldset>
                    <Fieldset
                        className="signup-item custom-signup-fieldset"
                        label="Category"
                        errorMessage={form.fields.category}
                        isMandatory={false}
                        icon={Triangle}
                        svgClassName="svg-triangle"
                    >
                        <select
                            className="common-select custom-signup-select"
                            name="country"
                            id=""
                            value={form.fields.category.value || ""}
                            {...events.fields.category}
                        >
                            <option value="">Select category</option>
                            {categoriesMapping.length > 0 &&
                                categoriesMapping.map((category, index) => (
                                    <option key={index} value={category.type}>
                                        {category.type}
                                    </option>
                                ))}
                        </select>
                    </Fieldset>
                    <Fieldset
                        className="signup-item custom-signup-fieldset"
                        label="Industry"
                        errorMessage={form.fields.industry}
                        isMandatory={false}
                        icon={Triangle}
                        svgClassName="svg-triangle"
                    >
                        <select
                            className="common-select custom-signup-select"
                            name="country"
                            id=""
                            value={form.fields.industry.value || ""}
                            {...events.fields.industry}
                        >
                            <option value="">Select industry</option>
                            {industriesMapping.length > 0 &&
                                industriesMapping.map((industry, index) => (
                                    <option key={index} value={industry.type}>
                                        {industry.type}
                                    </option>
                                ))}
                        </select>
                    </Fieldset>
                </div>
                <div className="signup-controls-wrapper">
                    <button
                        className={cn("common-btn custom-signup-control-btn", !isValid ? "disabled" : "")}
                        type="button"
                        onClick={() => onSendSignup()}
                        disabled={!isValid}
                    >
                        Signup
                    </button>
                    <button
                        className="common-btn custom-signup-control-btn"
                        type="button"
                        onClick={() => onChangeStatusSignupModal(false)}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        );
    }
}

export interface SignupProps {}

export const Signup = connect(
    (state: AppState, ownProps: SignupProps) => {
        const industriesMapping: IndustryMapping[] =
            FetchingState.isSuccess(state.mappings.industries) && state.mappings.industries.data;

        const categoriesMapping: CategoryMapping[] =
            FetchingState.isSuccess(state.mappings.categories) && state.mappings.categories.data;

        return {
            signupFormData: signupForm.selector(state.signupState.signupForm),
            industriesMapping: industriesMapping || [],
            categoriesMapping: categoriesMapping || []
        };
    },
    (dispatch: Dispatch, ownProps: SignupProps) => ({
        signupFormEvents: signupFormBindings.bind(dispatch, undefined),
        onChangeStatusSignupModal: (isOpen: boolean) => {
            dispatch(changeStatusSignupModalAction({ isOpen: isOpen }));
        },
        onUploadDropdowns() {
            dispatch(uploadMappingsForSignup({}));
        },
        onSendSignup() {
            dispatch(sendSignupAction({}));
        }
    })
)(SignupComponent);
